/**
 * The search-result deep link into the doc viewer.
 *
 * One module owns both ends: the header search bar (⌘K, on every surface)
 * writes it, DocViewerPage reads it. The link survives the cross-host hop other
 * surfaces make to reach the Docs page on the launch home — `launchUrl`
 * preserves the query string it is given.
 */

export const DOC_PARAM = 'doc';

/** The Docs page (on the launch home) with `docId` selected, for a cross-host jump. */
export function docDeepLinkPath(docId: string): string {
  return `/docs?${DOC_PARAM}=${encodeURIComponent(docId)}`;
}

/**
 * The current query string with `docId` deep-linked, for an in-surface
 * navigation — the other params ride along (on localhost ?capture/?tenant ARE
 * the host selection).
 */
export function withDocParam(search: string | URLSearchParams, docId: string): string {
  const next = new URLSearchParams(search);
  next.set(DOC_PARAM, docId);
  return next.toString();
}

/** The document a /docs URL deep-links to, or null. */
export function docIdFromSearch(search: string | URLSearchParams): string | null {
  const params = typeof search === 'string' ? new URLSearchParams(search) : search;
  return params.get(DOC_PARAM) || null;
}

/** The same query string with the deep link consumed. */
export function withoutDocParam(search: URLSearchParams): URLSearchParams {
  const next = new URLSearchParams(search);
  next.delete(DOC_PARAM);
  return next;
}
